import MarkdownIt from "markdown-it"

const inlineMd = MarkdownIt("default")

type Props = {
  children: string
  className?: string
}

export function Markdown({ children, className }: Props) {
  const html = inlineMd.render(children)

  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
  )
}
